import { State } from 'xstate';
import { cancelSubscription } from './cancelSubscription';

type CancelSubscriptionsMachine = typeof cancelSubscription;
type CancelSubscriptionState = State<CancelSubscriptionsMachine['context']>;

export const getCancelSubscriptionStatus = (
  machineState: CancelSubscriptionState
) => ({
  idle: machineState.matches('idle'),
  cancelSubscriptionLoading: machineState.matches('cancelSubscription'),
  cancelSubscriptionSuccess: machineState.matches('success'),
  cancelSubscriptionError: machineState.matches('error'),
});

export const getErrorCode = (machineState: CancelSubscriptionState) => {
  return machineState.context.error;
};

export const cancelSubscriptionSelectors = {
  getCancelSubscriptionStatus,
  getErrorCode,
};
